import { useStore } from "../../context/StoreContext";

export const AnnouncementBar = () => {
  const { config } = useStore();
  return (
    <div
      data-testid="announcement-bar"
      className="bg-ink text-white text-xs sm:text-sm font-medium py-2.5 px-4 text-center tracking-wide"
    >
      {config?.announcement_text || "🚚 Free shipping when you buy 2 units"}
    </div>
  );
};
